import { motion } from 'framer-motion'
import { Check, Calendar } from 'lucide-react'
import Button from '../ui/Button'

const ServicePackages = () => {
  const packages = [
    {
      id: 1,
      name: "Plan 1 - Occupation de Courte durée",
      price: "Tarif sur Demande",
      features: [
        "Enregistrement du Résident",
        "Répit de Jour",
        "Système de caméra de surveillance à l'entrée principale",
        "Détecteur de fumée",
        "Système d'alarme relié à une centrale",
        "Plan d'évacuation conforme",
        "Aide à la douche",
        "Aide à l'habillement",
        "Prise de tension artérielle/ saturomètre",
        "Accompagnement au visite médicale",
        "Service de loisirs et d'animation",
        "Sorties extérieures",
        "Salle Sensorielle"
      ]
    },
    {
      id: 2,
      name: "Plan 2 - Occupation par alternance",
      price: "Tarif sur Demande",
      features: [
        "Enregistrement du Résident",
        "Répit par alternance",
        "Système de caméra de surveillance à l'entrée principale",
        "Détecteur de fumée",
        "Système d'alarme relié à une centrale",
        "Plan d'évacuation conforme",
        "Aide à la douche",
        "Aide à l'habillement",
        "Prise de tension artérielle/ saturomètre",
        "Accompagnement au visite médicale",
        "Service de loisirs et d'animation",
        "Sorties extérieures",
        "Salle Sensorielle"
      ]
    },
    {
      id: 3,
      name: "Plan 3 - Occupation de Long Durée",
      price: "Tarif sur Demande",
      features: [
        "Réception des usagers",
        "Service standard de Ressource Intermédiaire",
        "Système de caméra de surveillance à l'entrée principale",
        "Détecteur de fumée",
        "Système d'alarme relié à une centrale",
        "Plan d'évacuation conforme",
        "Aide à la douche",
        "Aide à l'habillement",
        "Prise de tension artérielle/ saturomètre",
        "Accompagnement au visite médicale",
        "Service de loisirs et d'animation",
        "Sorties extérieures",
        "Visite des salles sensorielles"
      ]
    }
  ]

  return (
    <div className="mt-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-display font-bold gradient-text mb-4">
          Nos Packages de Services
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          Choisissez le plan qui correspond le mieux aux besoins de votre proche
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {packages.map((pkg, index) => (
          <motion.div
            key={pkg.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
          >
            <div className="glass-card p-8 h-full flex flex-col relative">
              {index === 1 && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-primary-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                    Recommandé
                  </span>
                </div>
              )}
              
              <h3 className="text-xl font-bold text-black mb-4">{pkg.name}</h3>
              <div className="text-3xl font-bold gradient-text mb-6">{pkg.price}</div>
              
              <ul className="space-y-3 flex-1 mb-8">
                {pkg.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start space-x-3">
                    <Check className="w-5 h-5 text-primary-500 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <Button 
                variant="primary" 
                className="w-full"
                icon={Calendar}
                onClick={() => window.open('/appointment', '_blank')}
              >
                Prendre un Rendez-vous
              </Button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default ServicePackages
